import { graphql } from 'react-relay';
import useLiveFragment from 'relay/useLiveFragment';
import { MoreSurveysBannerRefetchQuery } from './__generated__/MoreSurveysBannerRefetchQuery.graphql';
import { useMoreSurveysBannerQuery_profileUrlRef$key } from './__generated__/useMoreSurveysBannerQuery_profileUrlRef.graphql';

const fragment = graphql`
  fragment useMoreSurveysBannerQuery_profileUrlRef on Query
  @refetchable(queryName: "MoreSurveysBannerRefetchQuery") {
    endlessProfilerUrl
    demographicProfileUrl
    profilerUrl
    profileCompletionPercentage {
      profileCompletionPercentage
    }
    userData {
      firstName
    }
  }
`;

export function useMoreSurveysBannerQuery(
  profileUrlRef: useMoreSurveysBannerQuery_profileUrlRef$key,
) {
  return useLiveFragment<MoreSurveysBannerRefetchQuery, unknown>(fragment, profileUrlRef);
}
